// extracted by mini-css-extract-plugin
export var gif = "_dh-0";